import React from 'react';
import { CommonPrelanderV47 } from '../../components/CommonPrelanderV47';
import { QUIZ_SLIDES_V37 } from '../../shared/quiz-slides/quiz-slides-v37';

function PrelanderV56Page({ initialPrelander }) {
    return (
        <CommonPrelanderV47
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V37}
        />
    );
}

export {
    PrelanderV56Page
};
